/** Copy of the boxHistory page (Operations), ported from VentaHub. */
export const boxHistory = {
  title: 'Box history',
  description: 'What went into and out of boxes, and what moved between them.',
  chooseTitle: 'Choose a warehouse',
  chooseHint: 'The ledger is shown one warehouse and one window at a time.',
  truncated: 'Too many rows for this window, so the lists are cut short. Narrow the dates.',
  inward: 'Inward',
  outward: 'Outward',
  shift: 'Shifted between boxes',
  none: 'Nothing in this window.',
  noShifts: 'No shifts in this window.',
  emptyHint: 'Try a wider window, or clear the box and SKU filters.',
  download: {
    inward: 'Download inward',
    outward: 'Download outward',
    shift: 'Download shifts',
  },
  rows_one: '{{count}} row',
  rows_other: '{{count}} rows',
  filters: {
    warehouse: 'Warehouse',
    choose: 'Choose…',
    dates: 'Dates',
    boxes: 'Box codes',
    skus: 'SKU codes',
  },
  columns: {
    date: 'Date',
    party: 'Party',
    number: 'Number',
    type: 'Type',
    box: 'Box',
    sku: 'SKU',
    skuName: 'SKU name',
    quantity: 'Quantity',
    fromBox: 'From box',
    fromSku: 'From SKU',
    fromSkuName: 'From SKU name',
    toBox: 'To box',
    toSku: 'To SKU',
    toSkuName: 'To SKU name',
  },
} as const
